import { IValidatorFn } from 'app/interfaces/IValidatorFn';

import { IRadioOption } from 'app/interfaces/IRadioOption';
import { ISelectOption } from 'app/interfaces/ISelectOption';
import { format } from '../utils/string.util';

export const stagingOptions: Array<IRadioOption<boolean>> = [
    {
        value: true,
        label: stringResources.True
    },
    {
        value: false,
        label: stringResources.False
    }
];

export const externalStagingDataStoreTypeOptions: Array<IRadioOption<boolean>> = [
    {
        value: false,
        label: stringResources.External
    }
];

export const stagingDataStoreTypeOptions: Array<IRadioOption<boolean>> = [
    {
        value: true,
        label: stringResources.Workspace,
        description: stringResources.Staging_FabricBuiltIn_Desc
    },
    ...externalStagingDataStoreTypeOptions
];

export const cloudUnitOptions: Array<ISelectOption<number | undefined>> = [
    { label: stringResources.Auto, value: undefined },
    { label: '4', value: 4 },
    { label: '8', value: 8 },
    { label: '16', value: 16 },
    { label: '32', value: 32 }
];

export const cloudUnitOptionsForTrident: Array<ISelectOption<number | undefined>> = [
    { label: stringResources.Auto, value: undefined },
    { label: stringResources.Standard, value: 64 },
    { label: stringResources.Balanced, value: 128 },
    { label: stringResources.MaximumLabel, value: 256 }
];

export const preserveRulesValues = {
    acl: 'ACL',
    group: 'Group',
    owner: 'Owner',
    attributes: 'Attributes',
    creationDatetime: 'CreationDateTime',
    expiryDatetime: 'ExpiryDateTime'
};

export const preserveRulesOptions: Array<ISelectOption<string>> = [
    {
        label: stringResources.PreserveRules_ACL_Label,
        value: preserveRulesValues.acl,
        description: stringResources.PreserveRules_ACL_Description
    },
    {
        label: stringResources.PreserveRules_Owner_Label,
        value: preserveRulesValues.owner,
        description: stringResources.PreserveRules_Owner_Description
    },
    {
        label: stringResources.GroupLabel,
        value: preserveRulesValues.group,
        description: stringResources.PreserveRules_Group_Description
    }
];

export const preserveRulesAttributesOption: ISelectOption<string> = {
    label: stringResources.PreserveRules_Attributes_Label,
    value: preserveRulesValues.attributes,
    description: stringResources.PreserveRules_Attributes_Description
};

export const preserveRulesTimeOption: Array<ISelectOption<string>> = [
    {
        label: stringResources.PreserveRules_CreateDatetime,
        value: preserveRulesValues.creationDatetime
    },
    {
        label: stringResources.PreserveRules_ExpiryDatetime,
        value: preserveRulesValues.expiryDatetime
    }
];

export const dataConsistencyOptions: Array<IRadioOption<boolean>> = [
    {
        label: stringResources.Fail_When_Data_Inconsistency,
        description: stringResources.Fail_When_Data_Inconsistency_Description,
        value: false
    },
    {
        label: stringResources.Skip_When_Data_Inconsistency,
        description: stringResources.Skip_When_Data_Inconsistency_Description,
        value: true
    }
];

export const parallelOptions: Array<ISelectOption<number>> = [({ label: stringResources.Auto, value: undefined })]
    .concat((Array.apply(null, { length: 32 }) as undefined[]).map((_, index) => ({ label: `${index + 1}`, value: index + 1 })));

const diuMin: number = 4;

export const dataMovementUnitValidator: IValidatorFn[] = [
    (value: string) => {
        const num = parseInt(value, 10);
        if (value == null || (/^\d*$/.test(value) && num <= 256 && (num >= diuMin || num === 0))) {
            return undefined;
        }
        return format(stringResources.DataMovementUnitErrorMessage_template, diuMin.toString());
    }
];

export const parallelCopyValidator: IValidatorFn[] = [
    (value: string) => {
        const num = parseInt(value, 10);
        if (value == null || /^\d*$/.test(value) && num !== 0) {
            return undefined;
        }
        return stringResources.ValueMustBeAPositiveNumber;
    }
];

export const additionalColumnValueOptionsForFormatV2: Array<ISelectOption<string>> = [
    {
        label: '$$FILEPATH',
        value: '$$FILEPATH',
        tooltip: stringResources.CopySource_AdditionalColumns_FilePath_Description
    },
    {
        label: '$$FILENAME',
        value: '$$FILENAME'
    },
    {
        label: '$$COLUMN',
        value: '$$COLUMN',
        tooltip: stringResources.CopySource_AdditionalColumns_DupColumn_Description
    }
];

export const additionalColumnValueOptions: Array<ISelectOption<string>> = [
    {
        label: '$$COLUMN',
        value: '$$COLUMN',
        tooltip: stringResources.CopySource_AdditionalColumns_DupColumn_Description
    }
];

export const auditEntries: ReadonlyArray<{ key: string; label: string }> = [
    { key: '$$COLUMN', label: stringResources.Column },
    { key: '$$WORKSPACEID', label: stringResources.WorkspaceId },
    { key: '$$COPYJOBID', label: stringResources.CopyJobId },
    { key: '$$COPYJOBRUNID', label: stringResources.CopyJobRunIDWithSpace },
    { key: '$$COPYJOBNAME', label: stringResources.CopyJobName },
    { key: '$$NOW', label: stringResources.ExtractionTime },
    { key: '$$LOWERBOUND', label: stringResources.LowerBoundLabel }
] as const;
export const auditColumnValueOptions: Array<ISelectOption<string>> = auditEntries.map((e) => ({
    label: e.label,
    value: e.key
}));
export const auditColumnsFileValueOptions: Array<ISelectOption<string>> = [
    {
        label: stringResources.FilePath_Label,
        value: '$$FILEPATH'
    }
];
export const auditColumnsUpperboundOptions: Array<ISelectOption<string>> = [
    {
        label: stringResources.UpperBoundLabel,
        value: '$$UPPERBOUND'
    }
];
